import { useLocalStorage } from './useLocalStorage';

export const useDeckCategories = () => {
  const [categories, setCategories] = useLocalStorage('deckCategories', {
    'Uncategorized': []
  });

  const [deckCategoryMap, setDeckCategoryMap] = useLocalStorage('deckCategoryMap', {});

  const addCategory = (categoryName) => {
    if (categories[categoryName]) return false;

    setCategories({
      ...categories,
      [categoryName]: []
    });
    return true;
  };

  const deleteCategory = (categoryName) => {
    if (categoryName === 'Uncategorized') return false;

    const newCategories = { ...categories };
    delete newCategories[categoryName];

    // Move decks to Uncategorized
    const newDeckMap = { ...deckCategoryMap };
    Object.keys(newDeckMap).forEach(deckName => {
      if (newDeckMap[deckName] === categoryName) {
        newDeckMap[deckName] = 'Uncategorized';
      }
    });

    setCategories(newCategories);
    setDeckCategoryMap(newDeckMap);
    return true;
  };

  const renameCategory = (oldName, newName) => {
    if (oldName === 'Uncategorized') return false;
    if (categories[newName]) return false;

    const newCategories = { ...categories };
    newCategories[newName] = newCategories[oldName];
    delete newCategories[oldName];

    // Update deck mappings
    const newDeckMap = { ...deckCategoryMap };
    Object.keys(newDeckMap).forEach(deckName => {
      if (newDeckMap[deckName] === oldName) {
        newDeckMap[deckName] = newName;
      }
    });

    setCategories(newCategories);
    setDeckCategoryMap(newDeckMap);
    return true;
  };

  const assignDeckToCategory = (deckName, categoryName) => {
    if (!categories[categoryName]) return false;

    setDeckCategoryMap({
      ...deckCategoryMap,
      [deckName]: categoryName
    });
    return true;
  };

  const getDeckCategory = (deckName) => {
    return deckCategoryMap[deckName] || 'Uncategorized';
  };

  const getDecksByCategory = (categoryName) => {
    return Object.keys(deckCategoryMap)
      .filter(deckName => deckCategoryMap[deckName] === categoryName);
  };

  const getUncategorizedDecks = (allDeckNames) => {
    return allDeckNames.filter(deckName => !deckCategoryMap[deckName]);
  };

  const getCategorizedDecks = (allDeckNames) => {
    const categorized = {};

    // Initialize all categories
    Object.keys(categories).forEach(catName => {
      categorized[catName] = [];
    });

    // Add uncategorized category if needed
    if (!categorized['Uncategorized']) {
      categorized['Uncategorized'] = [];
    }

    // Categorize each deck
    allDeckNames.forEach(deckName => {
      const category = getDeckCategory(deckName);
      if (categorized[category]) {
        categorized[category].push(deckName);
      } else {
        categorized['Uncategorized'].push(deckName);
      }
    });

    return categorized;
  };

  return {
    categories,
    addCategory,
    deleteCategory,
    renameCategory,
    assignDeckToCategory,
    getDeckCategory,
    getDecksByCategory,
    getUncategorizedDecks,
    getCategorizedDecks
  };
};
